import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

const setSelectionAnchorRowKeyMutator: (
    tableView: TableView,
    newSelectionAnchorRowKey: string | null
) => void = mutatorAction(
    'setSelectionAnchorRowKey',
    function setSelectionAnchorRowKey(
        tableView: TableView,
        newSelectionAnchorRowKey: string | null
    ): void {
        tableView.selectionAnchorRowKey = newSelectionAnchorRowKey;
    }
);
export default setSelectionAnchorRowKeyMutator;
